import React from "react";
import ProgressCircle from "../../progressCircle";
import { UserCheck2 } from "lucide-react";
import { useUserProfileCompletion } from "@/hooks/users/useUserProfileCompletion";
import { Trans } from "react-i18next";
import { cn } from "@/components/utils";
import Tooltip from "@/components/tooltip";

const UserProfileCompletionIndicator = ({
  className,
  radius = 12,
  isCondensed = false,
}) => {
  const { completionPercentage } = useUserProfileCompletion();

  let circleVariant = "destructive";
  if (completionPercentage > 80) {
    circleVariant = "warning";
  }

  const label = (
    <Trans
      i18nKey="user_profile_completion.progress.label"
      values={{ percentage: completionPercentage }}
    />
  );

  return (
    <Tooltip value={isCondensed ? label : undefined}>
      <div className={cn("text-md flex items-center gap-2", className)}>
        {completionPercentage >= 100 ? (
          <UserCheck2 className="text-success" />
        ) : (
          <ProgressCircle
            radius={radius}
            min={0}
            max={100}
            value={completionPercentage}
            strokeWidth={4}
            variant={circleVariant}
          />
        )}
        {isCondensed ? `${completionPercentage}%` : label}
      </div>
    </Tooltip>
  );
};

export default UserProfileCompletionIndicator;
